import ls from "localstorage-slim";
import { readGatewayAccessTokenFromBrowserStorage } from "@variphigen/shared-dashboards";
import { isJwtExpired } from "../utils/jwt";

const TOKEN_KEY = "token";

function collectTokenCandidates(): string[] {
  const seen = new Set<string>();
  const candidates: string[] = [];

  const push = (raw: string | null | undefined) => {
    const token = raw?.trim();
    if (!token || seen.has(token)) return;
    seen.add(token);
    candidates.push(token);
  };

  push(readGatewayAccessTokenFromBrowserStorage());
  try {
    push(window.localStorage.getItem(TOKEN_KEY));
  } catch {
    // ignore
  }

  return candidates;
}

export function getToken(): string | null {
  for (const token of collectTokenCandidates()) {
    if (!isJwtExpired(token)) {
      return token;
    }
  }
  return null;
}

export function setToken(token: string): void {
  ls.set(TOKEN_KEY, token, { encrypt: true });
  window.localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  ls.remove(TOKEN_KEY);
  window.localStorage.removeItem(TOKEN_KEY);
}

/** Logout / session reset — removes every key for this app origin. */
export function clearAllBrowserStorage(): void {
  try {
    ls.clear();
  } catch {
    // ignore
  }
  window.localStorage.clear();
  window.sessionStorage.clear();
}

/** @deprecated Use clearAllBrowserStorage on logout */
export function clearAuthStorage(): void {
  clearAllBrowserStorage();
}

export const getAuthorizationHeader = (): Record<string, string> => {
  const token = getToken();
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};
